<div class="container mt-3">
  <fgbcl-lottos-list-v2 [isList]="true" [defaultSort]="0" />
</div>
